export const SIDEBAR = {
  APPSEC: 'Seguridad de Aplicaciones',
  APPSEC_CONTAINER_SCAN: 'Contenedores',
  APPSEC_DASHBOARD: 'Dashboard',
  APPSEC_DAST: 'DAST',
  APPSEC_SAST: 'SAST',
  APPSEC_SBOM: 'SBOM',
  APPSEC_SCA: 'SCA',
  APPSEC_SECRETS: 'Secretos',
  APPROVED_SOFTWARE: 'Software Aprobado',
  CHAT_LOGS: 'Logs de Conversaciones',
  CHAT_ASSISTANT: 'Qalea',
  CHAT_USER: 'Tú',
  CHAT_PLACEHOLDER: 'Escribe un mensaje...',
  CHAT_LIMIT_REACHED: 'Tu organización ha alcanzado el límite mensual del chatbot. Por favor contacta a soporte.',
  ASSETS: 'Activos',
  ASSET_INVENTORY: 'Inventario de Activos',
  GOVERNANCE: 'Gobernanza',
  SECURITY: 'Seguridad',
  OPERATIONS: 'Operaciones',
  DASHBOARD: 'Dashboard',
  WORKSPACE: 'Espacio de Trabajo',
  ASSET_MANAGEMENT: 'Gestión de Activos',
  AUTOMATED_PENTESTING: 'Pentesting Automatizado',
  AWARENESS_TRAINING: 'Formación en Ciberseguridad',
  BACKOFFICE: 'Backoffice',
  BILLING: 'Facturación',
  CLOUD_SECURITY: 'Seguridad en la Nube',
  CLOUD_SECURITY_DASHBOARD: 'Dashboard',
  CLOUD_MISCONFIGURANTIONS: 'Configuraciones',
  CODE_SCANNER: 'Escáner de Código',
  COMPLIANCE: 'Cumplimiento',
  COMPLIANCE_DATA: 'Datos de Compliance',
  CONTROLS: 'Controles',
  CRISIS_MANAGER: 'Crisis Manager',
  CUSTOMER_SUCCESS: 'Customer Success',
  DOCUMENTS: 'Documentos',
  TEXT_DOCUMENTS: 'Documentos de Texto',
  EASM: 'Superficie Externa',
  EASM_PUBLIC_DOMAINS: 'Dominios Públicos',
  EASM_BREACHES: 'Brechas Conocidas',
  EASM_CERTIFICATES: 'Certificados',
  EASM_DASHBOARD: 'Dashboard',
  EASM_VULNERABILITIES: 'Vulnerabilidades Externas',
  EDR: 'EDR',
  EDR_SIEM: 'EDR y SIEM',
  EMPLOYEE_DASHBOARD: 'Dashboard',
  EMPLOYEES_TRAINING: 'Formación en Ciberseguridad',
  EMPLOYEES_CENTER: 'Centro de Empleados',
  ENDPOINTS_COMPLIANCE: 'Hardening de Endpoints',
  ENDPOINT_PROTECTION: 'Protección de Endpoints',
  ENDPOINT_MONITORING: 'Monitorización de Endpoints',
  EVIDENCES: 'Evidencias',
  SUPPLIER_QUESTIONNAIRES: 'Cuestionarios',
  HOME: 'Inicio',
  INFRASTRUCTURE: 'Vulnerabilidades Internas',
  VULNERABILITIES: 'Vulnerabilidades',
  NON_CONFORMITIES: 'Dashboard de No Conformidades',
  PASSWORD_MANAGER: 'Gestión de Contraseñas',
  PASSWORD_VAULT: 'Password Vault',
  PEOPLE: 'Empleados',
  PHISHING_EXERCISES: 'Campañas de Phishing',
  POLICIES: 'Firma de Políticas',
  REPORTS: 'Informes',
  RISK_MANAGER: 'Risk Manager',
  ALERTS: 'Alertas',
  SERVERS_HARDENING: 'Hardening de Servidores',
  SERVERS: 'Servidores',
  STANDARD_EDITOR: 'Editor de Estándares',
  SUPPLIERS: 'Proveedores',
  SUPPLIERS_DASHBOARD: 'Gestor de Proveedores',
  TASKS: 'Task Manager',
  TRUST_CENTER: 'Centro de Confianza',
  LAPTOPS: 'Portátiles',
  CONNECTORS: 'Conectores',
  IDENTITIES: 'Identidades',
  HOME_DASHBOARD: 'Panel principal',
  RISK_ASSESSMENT: 'Evaluación de riesgos',
  MONITORING: 'Monitorización',
  OPERATIONAL_GOVERNANCE: 'Gobernanza Operacional',
  ORGANIZATION: 'Organización',
  ORGANIZATION_EMPLOYEE_DASHBOARD: 'Dashboard de Empleados',
  IT_INVENTORY: 'Inventario TI',
  ACCESS_REVIEW: 'Revisión de Accesos',
  SAAS_MANAGEMENT: 'Gestión de SaaS',
  AWARENESS: 'Concienciación',
  PHISHING: 'Phishing',
  SCANS: 'Escaneos',
  MDM: 'MDM Pro',
  MDM_LITE: 'MDM Lite',
  MDM_HOSTS: 'Equipos',
  MDM_GROUPS: 'Grupos',
  MDM_SOFTWARE: 'Software',
  MDM_DEVICE_POLICIES: 'Políticas',
  MDM_SCRIPTS: 'Scripts',
  SIEM: 'SIEM',
}

export const COMMON = {
  UNAUTHORIZED_TITLE: 'No Autorizado',
  UNAUTHORIZED_DESCRIPTION:
    'No estás autorizado para acceder a esta página,' + ' por favor contacta a tu administrador para solicitar acceso.',
  DOWNLOAD: 'Descargar',
  SAVE: 'Guardar',
  SAVING: 'Guardando...',
  STATUS: 'Estado',
  VIEW: 'Ver',
  DELETE: 'Eliminar',
  CANCEL: 'Cancelar',
  CONFIRM: 'Confirmar',
  SHOW_LESS: 'Mostrar menos',
  SHOW_MORE: 'Mostrar más',
  SELECT: 'Seleccionar',
  SEARCH: 'Buscar',
  NOT_FOUND: (label: string) => `${label} no disponibles.`,
  CLEAR: 'Limpiar',
  FILTER_BY: 'Filtrar por',
  OF: 'de',
  TOGGLE_SIDEBAR: 'Alternar Barra Lateral',
  ERROR_DIALOG_MESSAGE: 'Por favor, revisa la información e inténtalo de nuevo.',
  CLOSE_BUTTON_TEXT: 'Cerrar',
  COPIED_TO_CLIPBOARD: 'Copiado al portapapeles',
  ERROR_COPYING_TO_CLIPBOARD: 'Error al copiar al portapapeles',
  COPY_CODE: 'Copiar código',
  CREATING: 'Creando...',
  CREATE: 'Crear',
  EDIT: 'Editar',
  OK: 'Aceptar',
  LANGUAGES: {
    en: 'Inglés',
    es: 'Español',
  },
}

export const PAYWALL = {
  NOT_AVAILABLE: {
    DESCRIPTION:
      'Esta funcionalidad está actualmente fuera del alcance de tus capacidades,' +
      ' por favor envía una solicitud para ampliarla o habla con el equipo de Qalea',
    TITLE: 'Amplía tu alcance',
  },
  NOT_READY: {
    DESCRIPTION:
      'Actualmente estamos preparando esta capacidad para ti y estará lista pronto.' +
      ' Una vez que la configuración esté completa, tendrás acceso total. ¡Gracias por tu paciencia!',
    TITLE: 'Próximamente',
  },
  UNDER_MAINTENANCE: {
    DESCRIPTION: 'Esta funcionalidad está actualmente en mantenimiento,' + ' por favor intenta nuevamente más tarde.',
    TITLE: 'En Mantenimiento',
  },
  REQUEST_EXTENSION: 'Solicitar Ampliación',
  SCHEDULE_CALL: 'Agendar una Llamada',
}
